import api from "./api/api";
import {Config, DefaultConfig} from "./config";
import {getUserIdentity} from "./api/userIdentity";

import {_initRecorder} from "./recorder";
import {_initPlayer} from "./player";
import {initSentry} from "./sentry";
import Api from "./api/api";


export const init = async (config: Config) => {
    initSentry();
    const api = new Api(config.apiBaseUrl)
    const augmentedConfig = {...DefaultConfig, ...config};

    const playerApi = await _initPlayer(config.player, api)
    _initRecorder(api, augmentedConfig, playerApi.fnAdd)

    return {
        getRecordings: (fn: (r: Recording[]) => void) => {
            api.getAll().then(fn)
        },
        getMyRecordings: (fn: (r: Recording[]) => void) => {
            api.getByUser(getUserIdentity(augmentedConfig.cookie)).then(fn)
        },
        getById: (id: string, fn: (r: Recording | null | undefined) => void) => {
            api.getById(id).then(fn)
        },
        pauseAll: () =>{
            playerApi.pauseAll()
        }
    }
}
